import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EfIcon from 'elem/ui/ef-icon';
import { useProductStore } from '@elem/compPage/CES2025/ProductProvider';
import EfLink from '@elem/ui/ef-link';
import EfDialogYoutube from '@elem/ui/ef-dialog-youtube';
import { useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const A: FC = () => {
    const { t } = useLang('ces2025');
    const { pageStatus } = useProductStore();
    const [show, setShow] = useState(false);

    const handleJump = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name: t('A_title'),
            position: 'banner_1',
            button_name: t('A_link'),
        });
    };

    const handleWatchVideo = () => {
        setShow(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: "EcoFlow DELTA 3 Plus: World's Fastest Charging Power Certifed by SGS", // 固定传值
            position: 'ces 2025_1',
        });
    };

    return (
        <section className={styles.section} id="CES-2025-A">
            <EditorImg
                pc="https://websiteoss.ecoflow.com/upload/image/1733386087706/pc-ces-bg-1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1733386094276/m-ces-bg-1.jpg"
                className="banner"
                alt={t('A_title')}
                aria-label={t('A_title')}
            ></EditorImg>
            <div className="text-box">
                <div className="top">
                    <EfIcon pc={'https://websiteoss.ecoflow.com/upload/image/1735540415795/pc-ces-banner-icon1.png'} className="icon-1"></EfIcon>
                    <span className="dividing"></span>
                    <EfIcon pc={'https://websiteoss.ecoflow.com/upload/image/1735540422681/pc-ces-banner-icon2.png'} className="icon-2"></EfIcon>
                </div>
                <h5 className="title">{t('A_title')}</h5>
                <p className="sub-title-1">{t('A_subtitle1')}</p>
                <p className="sub-title-2">{t('A_subtitle2')}</p>
                {pageStatus === 'statusB' && (
                    <div className="btns">
                        <EfLink className="btn link" href="https://us.ecoflow.com" onClick={handleJump}>
                            {t('A_link')}
                        </EfLink>
                        <button className="btn video" onClick={handleWatchVideo}>
                            <span>{t('A_video')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0ZM9.2926 13.7581L13.9382 10.4054C14.2147 10.2059 14.2147 9.79413 13.9382 9.59456L9.2926 6.24188C8.96192 6.00324 8.5 6.23952 8.5 6.64733V13.3527C8.5 13.7605 8.96192 13.9968 9.2926 13.7581Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                )}
            </div>
            {show && <EfDialogYoutube open={show} src={'https://www.youtube.com/embed/AAF6-cKNseM?si=1DYdSdMb5adt3-jk'} callback={() => setShow(false)} />}
        </section>
    );
};

export default A;
